import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Grid, MenuItem , TextField, Select, InputLabel, FormControl, Button } from '@material-ui/core';
import { addUser } from '../../../store/admin';
import styles from "../styles";
import checkPermissions from "../../../utils/checkPermissions";
import StatusDisplay from "../StatusDisplay";

const AddUser = (props) => {
  // NOTE // these are the current users airline & user_type
  const { userAirline, userType, handleClose, status } = props
  const classes = styles();
  const dispatch = useDispatch();
  const [state, setState] = React.useState({ user_type: '', airline: '', firstName: '', lastName: '', email: '', password: '' });

  const handleChangeSelect = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const formatUser = () => {
    const output = 
    {
      email: state.email.toLowerCase(),
      password: state.password,
      first_name: state.firstName,
      last_name: state.lastName,
      airline_id: state.airline,
      user_type: state.user_type
    }
    return output
  }

  const submitUser = () => {
    dispatch(addUser(formatUser()));
  }

  const { airline, user_type, firstName, lastName, email, password } = state;

  return (
    <Grid container className={classes.paper} >
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="Email" variant="outlined" fullWidth value={email} onChange={handleChangeSelect} name="email" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="Password" type="password" autoComplete="current-password" variant="outlined" fullWidth value={password} onChange={handleChangeSelect} name="password" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="First name" variant="outlined" fullWidth value={firstName} onChange={handleChangeSelect} name="firstName" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <TextField label="Last name" variant="outlined" fullWidth value={lastName} onChange={handleChangeSelect} name="lastName" />
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
      <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="select-airline-label">Select Airline</InputLabel>
          <Select labelId="select-airline-label" value={airline} name="airline" onChange={handleChangeSelect} label="Select Airline" variant="outlined">
            {/* <MenuItem value='99'>All Airlines - 99</MenuItem> */}
            <MenuItem style={{ display: userAirline === 'TJ' ? 'block' : 'none' }} value="TJ">Tradewind Aviation - TJ</MenuItem>
            <MenuItem style={{ display: userAirline === '4N' ? 'block' : 'none' }} value="4N">Air North - 4N</MenuItem>
            {/* New partition */}
            <MenuItem value="ZW">Air wisconsin - ZW</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} className={classes.spacing}>
        <FormControl className={classes.formControl} fullWidth>
          <InputLabel id="select-role-label">Select role</InputLabel>
          <Select labelId="select-role-label" value={user_type} name="user_type" onChange={handleChangeSelect} label="Select role" variant="outlined">
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="pilot">Pilot/Concierge/Tier 1 Reservations</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="reservations">Reservations</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="scheduling">Scheduling/Dispatch</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="handler">Handler</MenuItem>
            <MenuItem style={{ display: checkPermissions(userType, userAirline, 'addNonAdminUser', true) }} value="read_only">Read only</MenuItem>
            <MenuItem value="admin">Admin</MenuItem>
          </Select>
        </FormControl>
      </Grid>
      <Grid container item xs={12} style={{marginTop: '8px'}}>
        <Grid item xs={3}></Grid>
        <Grid container justifyContent="center" item xs={3}>
          <Button variant="contained" color="primary" onClick={submitUser}>
            Submit
          </Button>
        </Grid>
        <Grid container justifyContent="center" item xs={3}>
          <Button variant="contained" style={{ backgroundColor: '#d13939', marginLeft: '8px' }} onClick={() => {handleClose(false)}}>
            Close
          </Button>
        </Grid>
      </Grid>
      <Grid container justifyContent="center" item xs={12}>
        { !status ? <div></div> : <StatusDisplay status={status} /> }
      </Grid>
    </Grid>
  );
}

export default AddUser